export default "__VITE_PUBLIC_ASSET__8a7a0b8d__"